import * as React from "react"

const SvgChatConversation = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M21 20.886a.9.9 0 0 1-.375-.075 1 1 0 0 1-.325-.225l-2.3-2.3H8q-.824 0-1.412-.588A1.93 1.93 0 0 1 6 16.286v-1h11q.824 0 1.413-.588.587-.587.587-1.412v-7h1q.824 0 1.413.587.587.588.587 1.413V19.86q0 .45-.3.737a.98.98 0 0 1-.7.288ZM4 12.46l1.175-1.175H15v-7H4zm-1 3.425a.98.98 0 0 1-.7-.288.98.98 0 0 1-.3-.737V4.286q0-.825.587-1.413A1.93 1.93 0 0 1 4 2.286h11q.824 0 1.413.587.587.588.587 1.413v7q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588H6l-2.3 2.3q-.15.15-.325.225a.9.9 0 0 1-.375.075Z" />
  </svg>
)
export default SvgChatConversation
